import React from "react";
import { array, object, number, bool } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";
import NewsWithNoImage from "../../../molecules/NewsWithNoImage";

import "./oranism.m.css";

const Organism = ({ stories, colNumber, styles, showSubHeading, totalCollection = 1 }) => {
  return (
    <div styleName={`base`} className={`news-wrapper base-${colNumber}`}>
      <div styleName="first-story" className="first-story">
        {stories.length > 0 && (
          <NewsWithImage
            story={stories[0].story}
            aspectRatio={[3, 2]}
            imageType="image3x2"
            datatrackinglabelpos={12}
            showDot={totalCollection < 3 && true}
            styles={styles}
            showSubHeading={showSubHeading}
          />
        )}
      </div>
      <div styleName="rest-stories" className="rest-stories">
        {stories.length > 1 &&
          stories
            .slice(1, 4)
            .map(({ story }, index) => (
              <NewsWithNoImage
                key={index}
                story={story}
                showDot={true}
                showExcerpt={false}
                styles={styles}
                showSubHeading={showSubHeading}
              />
            ))}
      </div>
      {stories.length > 4 && (
        <div styleName="rest-stories" className="rest-stories">
          {stories.length > 1 &&
            stories
              .slice(4, 7)
              .map(({ story }, index) => (
                <NewsWithNoImage
                  key={index}
                  story={story}
                  showDot={true}
                  showExcerpt={false}
                  styles={styles}
                  showSubHeading={showSubHeading}
                />
              ))}
        </div>
      )}
      {stories.length > 7 && (
        <div styleName="rest-stories" className="rest-stories">
          {stories.length > 1 &&
            stories
              .slice(7, 10)
              .map(({ story }, index) => (
                <NewsWithNoImage
                  key={index}
                  story={story}
                  showDot={true}
                  showExcerpt={false}
                  styles={styles}
                  showSubHeading={showSubHeading}
                />
              ))}
        </div>
      )}
    </div>
  );
};

Organism.propTypes = {
  stories: array.isRequired,
  colNumber: number,
  styles: object,
  showSubHeading: bool,
  totalCollection: number,
};

export default Organism;
